import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { EmptyStateModule } from '@michelin/theme';
import { ApplicationService } from '../application/application.service';
import { ImportFileXlsxComponent } from '../application/import-file-xlsx/import-file-xlsx.component';
import { ImportFileXlsx } from '../interfaces/importFileXlsx';

@Component({
  selector: 'mic-app-homexlsx',
  templateUrl: './homexlsx.component.html',
  styleUrls: ['./homexlsx.component.scss'],
  imports: [ImportFileXlsxComponent, EmptyStateModule]
})
export class HomexlsxComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly appService = inject(ApplicationService);
  private readonly cdr = inject(ChangeDetectorRef);

  importFileXlsxes: ImportFileXlsx[] = [];

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      if (params['name'] !== 'hbi') {
        this.appService.getApplicationByName(this.route.snapshot.params['name']).subscribe((response) => {
          this.importFileXlsxes = response.importFileXlsxes;
          this.cdr.detectChanges();
        });
      }
    });
  }
}
